import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ title, subtitle, lastUpdated, children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="legal-wrap">
      <div className="legal-inner">
        <Link to="/" className="legal-back">
          <ArrowLeft size={16} strokeWidth={1.8} /> Volver al inicio
        </Link>
        <span className="eyebrow" style={{ display: "block", textAlign: "left", marginBottom: 12 }}>{subtitle}</span>
        <h1 className="legal-h1">{title}</h1>
        <p className="legal-meta">Última actualización: {lastUpdated}</p>
        <div className="legal-body">
          {children}
        </div>
        <Link to="/" className="btn legal-cta">Volver al inicio</Link>
      </div>
    </div>
  );
}
